import React, { FC, memo } from 'react';
import { Button } from '../button/button.component';
import { Typography } from '../typography/typography.component';
import styles from './load-more.module.css';
import { useTranslation } from '~/shared/utils';

type Props = {
    fetching?: boolean;
    canLoadMore?: boolean;
    onLoadMore?: () => void;
    isLoadingMore?: boolean;
    totalCount?: number;
    currentCount?: number;
    buttonText?: string;
    itemsText?: string;
};

const LoadMore: FC<Props> = memo((props) => {
    const {
        canLoadMore,
        onLoadMore,
        isLoadingMore,
        totalCount,
        currentCount,
        buttonText,
        itemsText,
    } = props;
    const { translate } = useTranslation();

    return (
        <div className={styles.root}>
            <Typography variant="bodySmall" as="div">
                {translate('general.loadMore.progressText', {
                    currentCount: String(currentCount || 0),
                    totalCount: String(totalCount || 0),
                })}
                {' '}
                {itemsText || translate('general.loadMore.items')}
            </Typography>

            {/* Load More Button */}
            {canLoadMore && (
                <Button onClick={onLoadMore} disabled={isLoadingMore} variant="secondary">
                    {buttonText || translate('general.loadMore.buttonText')}
                </Button>
            )}
        </div>
    );
});

LoadMore.displayName = 'LoadMore';
export default LoadMore;
